<template>
  <div 
    class="progress-container border"
    :style="gridStyles"
  >
    <div 
      class="progress green"
      :style="percentage"
    >

    </div>
  </div>
</template>

<script>
export default {
  name:'ProgressBar',
  props: {
    msg: String,
    gridStyles:{
      type:Object,
      default:function(){return {}}
    },
    max:{
      type:Number,
      default:100
    },
    percentage:{
      type:Object,
      default:function(){
        return {
          width:"1%"
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress-container {
  box-sizing:border-box;
  display: grid;
  min-height:60px;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  border-radius:15px;
  overflow:hidden;
  max-width:90%;
}
.border {
  border: 4px solid #d9d9d9;
}

.green {
  background:green;
}

.progress {
  transition: all 333ms ease;
}
</style>
